import type { TypeUserRole } from './types'

/** Fields the role write endpoints persist. */
export function toRoleWritePayload(input: TypeUserRole) {
  return {
    name: input.name,
    description: input.description,
    default_dashboard: input.default_dashboard ?? null,
    permissions: input.permissions,
  }
}
